/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { maxPayByBonusesRequestSchema } from "./maxPayByBonusesRequestSchema.ts";
import { maxPayByBonusesResponseSchema } from "./maxPayByBonusesResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const cartMaxPayByBonusesCreateStatus200Schema = maxPayByBonusesResponseSchema;

export const cartMaxPayByBonusesCreateStatus400Schema = errorResponseSchema;

export const cartMaxPayByBonusesCreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const cartMaxPayByBonusesCreateStatus503Schema = errorResponseSchema;

export const cartMaxPayByBonusesCreateResponseSchema = z.union([
	cartMaxPayByBonusesCreateStatus200Schema,
	cartMaxPayByBonusesCreateStatus400Schema,
	cartMaxPayByBonusesCreateStatus401Schema,
	cartMaxPayByBonusesCreateStatus503Schema,
]);

export const cartMaxPayByBonusesCreateDataSchemaJson = maxPayByBonusesRequestSchema;

export const cartMaxPayByBonusesCreateDataSchemaXml = maxPayByBonusesRequestSchema;

export const cartMaxPayByBonusesCreateDataSchema = z.union([cartMaxPayByBonusesCreateDataSchemaJson, cartMaxPayByBonusesCreateDataSchemaXml]);
